module.exports = __webpack_public_path__ + "static/media/teapot.3bcfcbde.png";